import { authInstance } from './axios'
let url = process.env.REACT_APP_API_URL

export const gpsService = {
  getFleetLocation: async (params) => {
    const response = await authInstance
      .get(`${url}/gps/list/?` + new URLSearchParams(params))
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },

  getAllDevices: async () => {
    const response = await authInstance
      .get(`${url}/gps/getAllDevices`)
      .then(async (response) => {
        return response
      })
      .catch(function (error) {
        error.data = []
        return error
      })
    return response
  },
}
